import {
  closestCenter,
  DndContext,
  DragEndEvent,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { SortableContext, sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { move } from 'ramda';
import { components, GroupBase, OnChangeValue, ValueContainerProps } from 'react-select-5';

import { listSortingStrategy } from './helpers';

export const SortableValuesContainer = function <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: ValueContainerProps<Option, IsMulti, Group>,
) {
  const { selectProps } = props;
  const value = props.getValue();
  const items = value.map((option) => ({ ...option, id: selectProps.getOptionValue(option) }));

  function handleDragEnd(event: DragEndEvent) {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = value.findIndex((item) => selectProps.getOptionValue(item) === active.id);
    const newIndex = value.findIndex((item) => selectProps.getOptionValue(item) === over.id);

    const nextRes = move(oldIndex, newIndex, value) as OnChangeValue<Option, IsMulti>;
    props.setValue(nextRes, 'select-option');
  }

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );

  return (
    <components.ValueContainer {...props}>
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={items} strategy={listSortingStrategy}>
          {props.children}
        </SortableContext>
      </DndContext>
    </components.ValueContainer>
  );
};
